// Exclude vowels so (offensive) words can't be created by accident
const CHARS = '0123456789BCDFGHJKLMNPQRSTVWXZbcdfghjklmnpqrstvwxz';

export const makeRandomString = ({ length }: { length: number }): string => {
  const result = new Array<string>(length);
  const randomNumbers = crypto.getRandomValues(new Uint16Array(length));

  for (let i = 0; i < length; i++) {
    const randomCharIndex = Math.floor((randomNumbers[i] / 65536) * CHARS.length);
    result[i] = CHARS[randomCharIndex];
  }

  return result.join('');
};
